'use client';

import { Button } from '@/components/ui/button';
import { getEnvironmentConfig, shouldEnableSentry } from '@/utils/common/environment';
import { captureException } from '@sentry/nextjs';
import { signOut } from 'next-auth/react';
import Image from 'next/image';
import { useEffect } from 'react';
import Logoimg from '../public/images/logo.png';
export default function ErrorPage({
  error
}: Readonly<{
  error: Error & {
    digest?: string;
  };
}>) {
  useEffect(() => {
    if (shouldEnableSentry()) {
      captureException(error);
    }
  }, [error]);
  const {
    backgroundImage
  } = getEnvironmentConfig();
  const handleLoginAgain = async () => {
    try {
      await fetch('/api/auth/clear-session', {
        method: 'POST'
      });
    } catch (e) {
      console.error('Failed to clear server cookies:', e);
    }
    localStorage.clear();
    sessionStorage.clear();
    await signOut({
      callbackUrl: '/login',
      redirect: true
    });
  };
  return <div className="fixed inset-0 flex h-screen w-full items-center justify-center bg-cover bg-no-repeat" style={{
    backgroundImage
  }} data-sentry-component="ErrorPage" data-sentry-source-file="error.tsx">
      <div className="mx-4 w-[100%] rounded-xl bg-white px-5 py-7 backdrop-blur-xl backdrop-filter sm:w-[350px] md:mx-0 md:px-6 md:py-10 2xl:w-[450px] 2xl:px-10 2xl:py-14">
        <Image src={Logoimg} width={144} height={50} alt="TRS" className="m-auto mb-2" data-sentry-element="Image" data-sentry-source-file="error.tsx" />
        <p className="mt-4 text-center text-base md:text-xl 2xl:mt-6 2xl:text-2xl">
          An unexpected error has occurred. Please try again.
        </p>
        <Button variant="login" className="mt-4 w-full md:mt-6 2xl:mt-8" onClick={() => window.location.reload()} data-sentry-element="Button" data-sentry-source-file="error.tsx">
          Refresh Page
        </Button>
        <Button variant="login" className="mt-2 w-full" onClick={handleLoginAgain} data-sentry-element="Button" data-sentry-source-file="error.tsx">
          Back to Login
        </Button>
      </div>
    </div>;
}